import { createAction } from '@reduxjs/toolkit';
import { startAppListening } from '../listenerMiddleware';
import { setAuthenticated, setUserProfile } from '../slices/userSlice';
import { setAuthError } from '../slices/appSlice';
import { apiSlice } from '../slices/apiSlice';
import { YANDEX_OAUTH_CALLBACK_PATH, YANDEX_OAUTH_STATE_KEY } from '../constants/yandexAuth';

export const yandexAuthCallbackRequested = createAction('auth/yandexAuthCallbackRequested');

startAppListening({
	actionCreator: yandexAuthCallbackRequested,
	effect: async (_action, listenerApi) => {
		if (window.location.pathname !== YANDEX_OAUTH_CALLBACK_PATH) return;

		const params = new URLSearchParams(window.location.search);
		const code = params.get('code');
		const dev = params.get('dev');
		const expectedState = window.sessionStorage.getItem(YANDEX_OAUTH_STATE_KEY);
		let returnedState = params.get('state');
		if (dev === 'true') {
			returnedState = expectedState;
		}
		window.sessionStorage.removeItem(YANDEX_OAUTH_STATE_KEY);

		if (!code || !expectedState || expectedState !== returnedState || params.has('error')) {
			listenerApi.dispatch(setAuthError(true));
			window.history.replaceState({}, '', '/');
			return;
		}

		const endpoint = dev === 'true' ? apiSlice.endpoints.yandexAuthDev : apiSlice.endpoints.yandexAuth;

		try {
			const { user } = await listenerApi.dispatch(endpoint.initiate({ code })).unwrap();
			listenerApi.dispatch(
				setUserProfile({
					firstName: user.first_name,
					lastName: user.last_name,
					email: user.email,
					avatarUrl: user.avatar_url,
				})
			);
			listenerApi.dispatch(setAuthenticated(true));
			window.history.replaceState({}, '', '/');
		} catch (error) {
			console.log(error);
			listenerApi.dispatch(setAuthError(true));
		}
	},
});
